import { useSelector } from "react-redux";
import { Navigate } from 'react-router-dom';
import { selectCurrentUserFunctions } from "store/selectors";
import { checkFunctionHaveCode } from "store/user/functions";

/**
 * Kiểm tra quyền truy cập route (function permission)
 * - Scope check được xử lý động bởi component sử dụng useFunctionPermission hook
 * - Sidebar và route visibility sử dụng danh sách functions của currentUser
 */
const PrivateRoutes = ({ func, children, isMultipleFuncs = false }) => {
    const functions = useSelector(selectCurrentUserFunctions);

    // Nếu route có thể truy cập từ nhiều func
    if (isMultipleFuncs) {
        if (!Array.isArray(func)) return <Navigate to='/errors/forbidden' replace />;

        // Check function permission (synchronous)
        const hasAnyFunctionPermission = func.some(f =>
            checkFunctionHaveCode(functions, f)
        );

        if (!hasAnyFunctionPermission) {
            return <Navigate to='/errors/forbidden' replace />;
        }

        return children;
    }

    // Check function permission (synchronous)
    if (!checkFunctionHaveCode(functions, func)) {
        return <Navigate to='/errors/forbidden' replace />;
    }

    // Scope check được delegate cho component thông qua useFunctionPermission hook
    // Component sẽ gọi getFunctionScope động khi cần thiết
    return children;
};

export default PrivateRoutes;
